import React from "react";
import { Typography, RaiseColors } from "componentLibrary";
import CustomDialog from "./CustomDialog";
import { jsx as _jsx } from "react/jsx-runtime";
var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    bodyMessage = _ref.bodyMessage,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    onClose = _ref.onClose,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? "Cancel" : _ref$cancelText,
    _ref$confirmText = _ref.confirmText,
    confirmText = _ref$confirmText === void 0 ? "Confirm" : _ref$confirmText,
    _ref$disableCloseOnBa = _ref.disableCloseOnBackdropClick,
    disableCloseOnBackdropClick = _ref$disableCloseOnBa === void 0 ? false : _ref$disableCloseOnBa;
  var bodyContent = /*#__PURE__*/_jsx(Typography, {
    variant: "paragraph_small",
    weight: "regular",
    color: RaiseColors.grayscale900,
    children: bodyMessage
  });
  return /*#__PURE__*/_jsx(CustomDialog, {
    open: open,
    title: title,
    onClose: onCancel || onClose,
    disableCloseOnBackdropClick: disableCloseOnBackdropClick,
    cancelText: cancelText,
    primaryButtonText: confirmText,
    onPrimaryAction: onConfirm,
    bodyContent: bodyContent,
    "data-testid": "confirmation-dialog"
  });
};
export default ConfirmationDialog;